import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useTr } from "@/i18n";

const MATRIMONIO_URL =
  "https://www.matrimonio.com/musica-matrimonio/dj-magix-&-maditaly--e403207";

const reviews = [
  {
    quote:
      "Ottima esperienza con questo fornitore. Ottimo servizio e prezzo onesto. Da considerare per altri eventi.",
    name: "Guillermo",
    event: "Matrimonio.com — 02/04/2026",
    rating: 5,
  },
  {
    quote:
      "Cosa dire di lui: è stato attento, paziente, e alla festa è stato magistrale.",
    name: "Ornella",
    event: "Matrimonio.com — 02/04/2026",
    rating: 5,
  },
  {
    quote: "Non poteva andare meglio. Davvero una bella esperienza. Complimenti.",
    name: "Alessandro",
    event: "Matrimonio.com — 06/08/2026",
    rating: 4,
  },
];

export default function Testimonials() {
  const tr = useTr();
  return (
    <section id="recensioni" data-testid="testimonials-section" className="py-24 bg-[#0B0B0B]">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow={tr("testimonials.eyebrow", "Recensioni")}
          title={tr("testimonials.title", "Dicono di Me")}
          accent={tr("testimonials.accent", "La soddisfazione di chi ha ballato con DJ Magix.")}
          testid="testimonials-heading"
        />
        <div className="flex justify-center px-6 mb-8">
          <a
            data-testid="testimonials-matrimonio-badge"
            href={MATRIMONIO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 rounded-full gold-frame px-6 py-3 text-xs text-[#F7DE8B] hover:bg-[#E2B857]/10 transition-colors"
          >
            <Star size={15} className="fill-[#E2B857] text-[#E2B857]" />
            <span>
              <b className="text-[#E2B857]">4.8/5</b> {tr("testimonials.badge.pre", "su Matrimonio.com · Consigliato dal")}{" "}
              <b className="text-[#E2B857]">96%</b> {tr("testimonials.badge.post", "delle coppie")}
            </span>
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 px-6">
          {reviews.map((r, i) => (
            <motion.blockquote
              key={r.name}
              data-testid={`testimonial-card-${i}`}
              className="gold-frame rounded-xl bg-[#111111] p-7 flex flex-col"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            >
              <Quote size={26} className="text-[#E2B857] rotate-180" strokeWidth={1.5} />
              <div className="flex gap-1 mt-4" aria-label={`${r.rating} stelle su 5`}>
                {[...Array(5)].map((_, s) => (
                  <Star
                    key={s}
                    size={15}
                    className={
                      s < r.rating
                        ? "fill-[#E2B857] text-[#E2B857]"
                        : "text-[#57451d]"
                    }
                  />
                ))}
              </div>
              <p className="font-accent italic text-lg text-[#E2C882]/90 leading-relaxed mt-4 flex-1">
                “{r.quote}”
              </p>
              <footer className="mt-6 pt-4 border-t border-[rgba(226,184,87,0.18)]">
                <p className="font-display text-sm font-semibold text-[#F7DE8B] tracking-wide">
                  {r.name}
                </p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#BFA45D] mt-1">
                  {r.event}
                </p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
